<template>
  <t-form label-width="80px">
    <CptData :data="props.attribute.cptTableData" :cptDataForm="props.cptDataForm" />
    <e-collapse title="地图配置" :expand="true">
      <t-form-item label="背景颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="props.attribute.bgColor" enableAlpha
          size="small" />
      </t-form-item>
      <t-form-item label="文本颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="props.attribute.textColor" enableAlpha
          size="small" />
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number v-model="props.attribute.radius" :min="0" :max="500" size="large" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="地图缩放级别">
        <t-input-number v-model="props.attribute.zoom" :min="3" size="large" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="默认打开">
        <t-radio-group size="small" v-model="attribute.isOpen">
          <t-radio-button :value="1">是</t-radio-button>
          <t-radio-button :value="0">否</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="中心坐标X轴">
        <t-input-number v-model="props.attribute.centerx" :step="0.000001" size="large" :decimal-places="6" />
      </t-form-item>
      <t-form-item label="中心坐标y轴">
        <t-input-number v-model="props.attribute.centery" :step="0.000001" size="large" :decimal-places="6" />
      </t-form-item>

      <!-- <t-form-item label="地图样式地址">
            <t-textarea v-model="props.attribute.tareaValue" placeholder="请输入内容" />
          </t-form-item> 
          <t-form-item label="">
            <t-link href="https://api.map.baidu.com/" >自定义地图平台</t-link>
          </t-form-item> -->
    </e-collapse>
  </t-form>
</template>

<script setup>
import CptData from '@/components/element/options/comp/cpt-data'
const props = defineProps({
  attribute: Object,
  cptDataForm: Object,
})
</script>